import styled from 'styled-components';

export const SerchBox = styled.div`
.search-header{
    display: flex;
    align-items: center;
    background: #fff;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 10px;
    padding: 10px;
    max-width: 680px; 
    width: 100%;
    @media screen and (max-width:1199px) { }

    @media screen and (max-width:991px) { }

    @media screen and (max-width:767px) { 
        
    } 
    @media screen and (max-width:575px) {
        flex-wrap: wrap;
        gap: 10px;
        justify-content: end;
    }
    .input-group{
        flex-wrap: nowrap;
       .form-control{
            border: none;
            padding-top: 2px;
            padding-bottom: 2px;
            font-family: "Jost", sans-serif;
            font-size: 14px;
            font-weight: normal;
            line-height: 20px;
            padding-left: 0px;
        @media screen and (max-width:767px) { 
            padding-left: 11px;
        }
             @media screen and (max-width:360px) { 
            padding-left: 0px !important;
        }
      }
    }
}
     .css-13cymwt-control {
      border: none;
        white-space: nowrap;
}
.css-b62m3t-container {
    position: relative;
    box-sizing: border-box;
    max-width: 204px;
    margin-left: 5px;
    margin-right: 6px;
}
   .css-1jqq78o-placeholder{
    white-space: nowrap;
    padding: 0 !important;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 400;
    color:#333;
    line-height: 20px;
    width: 95px;
    color:#333;
}
.css-1jqq78o-placeholder:focus-visible {
    border:none;
   box-shadow:none;
   outline: none;
   
 }
.css-1xc3v61-indicatorContainer {
    display: none;
}
.css-tj5bde-Svg{
      display: none;
}

 .css-1hb7zxy-IndicatorsContainer {
    display: none;
}
 .css-t3ipsp-control{
        border:none!important;
        box-shadow:none !important;
        outline: none !important;
        padding:0 !important;
    }
  .css-15lsz6c-indicatorContainer{
    display:none !important;
 }  
 
 .css-1nmdiq5-menu{
   width:240px !important; 
   z-index: 9 !important;
 }

.css-1wy0on6 {
    display: none;
}
.css-166bipr-Input{
   width:240px !important; 
}

.css-hlgwow{
     width:150px;
   }
`;

export const InputGroupIcon = styled.div`
    padding-right: 10px;

    .search-group-icon{
        width: 40px;
        height: 40px;
        background: #F9DC70;
        border-radius: 10px;
        padding: 10px;
    }
`;